import { simpleFetch } from '@api/fetchers';
import { getHost } from '@utils/api-helper/host';
import { PrimeTrialPromoApiResponse } from './types';

const getAuthOptions = (accessToken: string) => ({
  authorization: accessToken
});

const host = getHost();

export default function fetchPrimeTrialPromoDetails({
  goalUID,
  accessToken
}: {
  goalUID: string;
  accessToken: string;
}): Promise<PrimeTrialPromoApiResponse> {
  if (!accessToken) {
    return Promise.reject(new Error('Access token is required'));
  }

  return simpleFetch(`${host}v2/library/landing-page/?goal_uid=${goalUID}`, {
    ...getAuthOptions(accessToken)
  });
}
